import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DISPLAY_LANG } from "../../../config";
import { editDnsPageTitle, editDnsPageFormBtnText } from '../../../api/user/active-services/dns';
import { editDnsServers, getUserSingleDomains } from "../../../api/user/active-services/domain";
import Loading from "../../../components/loading";
import './edit-dns.css';

export default function EditDomainDNS() {
    const [dnsList, setDnsList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [orderId, setOrderId] = useState('');
    const [showSpiner, setShowSpiner] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const loadingData = async () => {
            const resDNSList = await getUserSingleDomains(id);
            setDnsList(resDNSList.dns_list);
            setOrderId(resDNSList.order_id);
            setLoading(false);
        };

        loadingData();
        window.scrollTo(0, 0);
    }, [id]);

    const handleChange = (index, event) => {
        const value = event.target.value;

        setDnsList(prev => {
            const copy = [...prev];
            copy[index] = value;
            return copy;
        });
    };

    if (loading) {
        return <Loading />;
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        setShowSpiner(true);

        try {
            const res = await editDnsServers(orderId, dnsList[0], dnsList[1]);

            if (res.status_code === 500) {
                alert(res.response.message);
                setShowSpiner(false);
            }

            if (res.status_code === 200) {
                navigate(-1);
            }

        } catch (error) {
            console.log(error);
            setShowSpiner(false);
            alert('Error');
        }
    };

    return (
        <div className='EditDomainDNS wrapper'>
            <h1 className="edit-dns-heading">{editDnsPageTitle[DISPLAY_LANG]}</h1>

            <form className="edit-dns-form" onSubmit={onSubmit}>
                <input type="text" value={dnsList[0]} onChange={(e) => handleChange(0, e)} />
                <input type="text" value={dnsList[1]} onChange={(e) => handleChange(1, e)} />

                <button type="submit" className="btn flex-center" disabled={showSpiner}>
                    {editDnsPageFormBtnText[DISPLAY_LANG]}
                    {showSpiner && <span className="spinner"></span>}
                </button>
            </form>
        </div>
    )
}